import { Card } from "../../../components/card.component";
import { PageHeader } from "../../../components";
import { HHAExchangeConfigEdit } from "../../../features/hhaConfig/hhaExchangeConfigEdit.component";

export function PageHHAConfigEdit() {
  return (
    <Card header={<PageHeader title="Edit HHA Configuration" />}>
      <HHAExchangeConfigEdit />
    </Card>
  );
}